"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskRecurring;
        (function (taskRecurring) {
            var createOrEdit;
            (function (createOrEdit) {
                function init() {
                    appn.tasks.initRecurring();
                }
                createOrEdit.init = init;
            })(createOrEdit = taskRecurring.createOrEdit || (taskRecurring.createOrEdit = {}));
        })(taskRecurring = views.taskRecurring || (views.taskRecurring = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
